package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Represents a game event (announcement, dice roll, combat, etc.).
 */
@Serializable
data class GameEvent(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("type")
    val type: String,

    @SerialName("triggered_by")
    val triggeredBy: String,

    @SerialName("target_participants")
    val targetParticipants: List<String>,

    @SerialName("content")
    val content: EventContent,

    @SerialName("created_at")
    val createdAt: Instant
) {
    /**
     * Returns the EventType enum value for this event.
     */
    val eventType: EventType
        get() = EventType.valueOf(type)
}
